<template>
    <div id="report-selection">
        <h2>Reports for {{ [ month, "MM" ] | moment("MMMM") }} {{ year }}</h2>
        <div class="my-2">
        <router-link class="btn btn-sm btn-outline-primary mr-2" :to="{ name: 'report_year', params: { report_year: year }}">Back</router-link>
        </div>
        <table class="table table-hover table-striped table-bordered table-sm">
            <thead class="thead-dark">
            <tr>
                <th>Client</th>
                <th>Product</th>
                <th></th>
            </tr>
            </thead>
            <tr v-for="client in available_reports">
                <td class="align-middle">{{ client.name }}</td>
                <td class="align-middle">{{ client.product }}</td>
                <td class="text-right align-middle">
                    <a class="btn btn-sm" v-bind:href="'/admin/reports/report/' + client.id + '/' + year + '/' + month">View Report</a>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "ReportSelect",
        props: ['clients', 'month', 'year', 'invoices'],
        data() {
            return {
                available_reports: []
            }
        },
        mounted() {
            this.updateReportsAvailable();
        },
        methods: {
            updateReportsAvailable: function(){
                let clients_with_reports = [];
                this.clients.forEach((client) => {
                    // if (client.invoices) {
                    //     client.invoices.forEach((invoice) => {
                    //         if (moment(invoice.date).format('YYYY') === this.year && moment(invoice.date).format('MM') === this.month) {
                                clients_with_reports.push(client);
                    //         }
                    //     })
                    // }
                });
                this.available_reports = clients_with_reports;
            }
        },
        watch: {
            invoices: function(){
                this.updateReportsAvailable();
            }
        }
    }
</script>

<style scoped>

</style>
